//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.AECDesign.js";
import "../no/Builder.js";
let d=[[[0,"BoolValue",1,0],[0,"Category",1,0],[0,"ComponentType",1,0],[0,"DoubleValue",1,0],[0,"IntValue",1,0],[0,"PropertiesRequisiteType",1,0],[0,"Property",1,0],[0,"StringValue",1,0]],[[["nPartCount","selectParts"],"GetSelectParts",{},0,0],[["selectParts"],"SetSelectParts",{},1,0],[["isReclassify"],"SetReclassify",{},1,0],[["propertyName","stringValue","strDataType","strRequisite"],"SetStringValueAndTypeAsPropertyName",{},4,0],[["propertyName","doubleValue","strDataType","strRequisite"],"SetDoubleValueAndTypeAsPropertyName",{},4,0],[["propertyName","intValue","strDataType","strRequisite"],"SetIntValueAndTypeAsPropertyName",{},4,0],[["propertyName","boolValue","strDataType","strRequisite"],"SetBoolValueAndTypeAsPropertyName",{},4,0]],[]];
SPLM.Features.AECDesign.BIMClassificationBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.AECDesign.BIMClassificationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.AECDesign.BIMClassificationBuilder.RequisiteTypes = Object.freeze({
    "All" : "All", "Mandatory" : "Mandatory", "Optional" : "Optional", "UserDefined" : "UserDefined"});

export default SPLM;